import PillIcon from '../../../../icons/PillIcon';
import { useStyles } from '../../styles';
import { QeScoreKpiBreakdownMetric } from '../../interfaces';
import { KPIMetricEntry } from './KPIMetricEntry';

interface QEScoreBreakdownProps {
  metrics: QeScoreKpiBreakdownMetric[];
}

export function QEScoreBreakdown({ metrics }: QEScoreBreakdownProps) {
  const classes = useStyles();
  const mid = Math.ceil(metrics.length / 2);
  const leftMetrics = metrics.slice(0, mid);
  const rightMetrics = metrics.slice(mid);
  return (
    <div
      className={`rounded-lg shadow-sm border h-full flex flex-col ${classes.qeBreakdownContainer}`}
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0">
        <h3 className={`text-xl font-semibold ${classes.qeBreakdownTitle}`}>
          QE Score breakdown
        </h3>
        <div
          className={`flex flex-wrap gap-3 sm:gap-4 text-xs ${classes.qeBreakdownLegend}`}
        >
          <div className="flex items-center gap-1.5">
            <PillIcon className={classes.qeBreakdownSuccessIcon} />
            <span className={`text-sm ${classes.kpiMetricNotApplicableValue}`}>
              Achieving / Progressing
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <PillIcon className={classes.qeBreakdownErrorIcon} />
            <span className={`text-sm ${classes.kpiMetricNotApplicableValue}`}>
              Needs Analysis
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 sm:gap-x-6 md:gap-x-8 flex-1">
        <div className="flex flex-col">
          {leftMetrics.map((metric, idx) => (
            <KPIMetricEntry key={idx} metric={metric} />
          ))}
        </div>
        <div className="hidden md:flex md:flex-col">
          {rightMetrics.map((metric, idx) => (
            <KPIMetricEntry key={idx} metric={metric} />
          ))}
        </div>
      </div>

      {/* Mobile: show right column below on single column layout */}
      <div
        className={`md:hidden mt-6 pt-6 border-t flex flex-col flex-1 ${classes.qeBreakdownMobileDivider}`}
      >
        {rightMetrics.map((metric, idx) => (
          <KPIMetricEntry key={idx} metric={metric} />
        ))}
      </div>
    </div>
  );
}
